function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import _ from 'lodash';
import { Pressable } from 'react-native';
import Colors from '../colors';
import Spacer from '../spacer';
const StyledContainer = styled.View`
  flex-direction: row;
  justify-content: center;
`;
const StyledPageIndicator = styled.View`
  background-color: ${props => props.activeItem ? props.activeColor : props.inactiveColor};
  height: 12px;
  width: 12px;
  border-radius: 50px;
`;
export default function PageControl(props) {
  const [active, setActive] = useState(props.active);

  const onChange = i => {
    setActive(i);
    props.stepPress(i);
  };

  return /*#__PURE__*/React.createElement(StyledContainer, null, _.times(props.items, i => /*#__PURE__*/React.createElement(Fragment, {
    key: i
  }, /*#__PURE__*/React.createElement(Pressable, {
    onPress: () => onChange(i)
  }, /*#__PURE__*/React.createElement(StyledPageIndicator, _extends({
    activeItem: active === i
  }, props))), props.items !== i + 1 && /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    width: true
  }))));
}
PageControl.defaultProps = {
  activeColor: Colors.purple400,
  inactiveColor: Colors.purple50,
  active: 0,
  items: 3,
  stepPress: () => {}
};
PageControl.propTypes = {
  activeColor: PropTypes.string,
  inactiveColor: PropTypes.string,
  active: PropTypes.number,
  items: PropTypes.number,
  stepPress: PropTypes.func
};
//# sourceMappingURL=index.js.map